import { useState, useEffect } from "react";
import { Phone } from "lucide-react";
const heroBg = "/images/hero-bg.webp";

const stats: { value: string; label: string }[] = [
  { value: "4ème génération", label: "de savoir-faire familial" },
  { value: "79 ans", label: "d'expérience" },
  { value: "+10 000", label: "projets réalisés" },
  { value: "100%", label: "engagés à vos côtés" },
];

const HeroSection = () => {
  const [emergencyMode, setEmergencyMode] = useState(false);
  const [emergencyPhone, setEmergencyPhone] = useState("0102030405");
  const [emergencyLabel, setEmergencyLabel] = useState("Urgence Infiltration");

  useEffect(() => {
    const fetchSettings = async () => {
      const { supabase } = await import("@/integrations/supabase/client");
      const { data } = await supabase
        .from("site_settings")
        .select("emergency_mode, emergency_phone, emergency_label")
        .eq("id", "main")
        .single();
      if (data) {
        setEmergencyMode(data.emergency_mode);
        setEmergencyPhone(data.emergency_phone);
        setEmergencyLabel(data.emergency_label);
      }
    };
    fetchSettings();
  }, []);

  return (
    <section id="accueil" className="relative min-h-[85vh] flex items-center justify-center overflow-hidden pb-8 sm:pb-12">
      <div className="absolute inset-0">
        <img src={heroBg} alt="Couvreur professionnel au travail" className="w-full h-full object-cover" width={1804} height={1080} fetchPriority="high" />
        <div className="absolute inset-0" style={{ backgroundColor: "hsl(213 26% 24% / 0.8)" }} />
        <div className="absolute inset-0 bg-gradient-to-t from-secondary via-secondary/30 to-transparent" />
      </div>

      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto animate-fade-in-up pt-10 sm:pt-0">
        <h1 className="text-3xl sm:text-5xl lg:text-6xl font-bold leading-tight mb-4 sm:mb-6">
          <span className="text-gradient-tile">HNJR Couverture</span>
          <br />
          <span style={{ color: "white" }}>Votre expert en travaux de toiture dans les Yvelines</span>
        </h1>
        <p className="text-base sm:text-lg md:text-xl max-w-2xl mx-auto mb-6 sm:mb-8 font-body" style={{ color: "hsl(0 0% 100% / 0.8)" }}>
          <strong>Couverture</strong>, <strong>charpente</strong>, <strong>zinguerie</strong>, <strong>isolation</strong>…
          Faites confiance à nos artisans couvreurs qualifiés dans le 78.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center mb-8 sm:mb-16">
          {emergencyMode ? (
            <a
              href={`tel:${emergencyPhone.replace(/\s/g, "")}`}
              className="cta-button text-base px-8 py-4 inline-flex items-center gap-2"
            >
              {emergencyLabel}
              <Phone className="w-5 h-5" />
            </a>
          ) : (
            <a href="/devis" className="cta-button text-base px-8 py-4">
              Estimer mes travaux
            </a>
          )}
          <a href="#services" className="cta-button-outline text-base px-8 py-4" style={{ borderColor: "white", color: "white" }}>
            Nos services
          </a>
        </div>

        <div className="grid grid-cols-2 sm:flex sm:justify-center gap-4 sm:gap-8 md:gap-16">
          {stats.map((stat) => (
            <div key={stat.label} className="stat-item">
              <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-gradient-tile font-heading">{stat.value}</div>
              <div className="text-xs sm:text-sm mt-1" style={{ color: "hsl(0 0% 100% / 0.6)" }}>{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
